import { useContext, useReducer, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Store } from '../Store';
import LoadingBox from '../components/LoadingBox';
import useAxios from '../hooks/useAxios';
import { getError } from '../utils';

const reducer = (state, action) => {
  switch (action.type) {
    case 'CREATE_REQUEST':
      return { ...state, loadingCreate: true };
    case 'CREATE_SUCCESS':
      return {
        ...state,
        loadingCreate: false,
      };
    case 'CREATE_FAIL':
      return { ...state, loadingCreate: false };

    default:
      return state;
  }
};

export default function DailyReportScreenSave(props) {
  const axios = useAxios();
  const [{ loadingCreate }, dispatch] = useReducer(reducer, {
    loadingCreate: false,
  });

  const { dailyReport, showDailySaveModal, setShowDailySaveModal, isUpdate } =
    props;

  const navigate = useNavigate();
  const { search } = useLocation();
  const redirectInUrl = new URLSearchParams(search).get('redirect');
  const code = new URLSearchParams(search).get('code');
  const redirect = redirectInUrl ? redirectInUrl : '/';

  const [description, setDesctiption] = useState('');
  const [excessCache, setExcessCache] = useState();
  const [missingCache, setMissingCache] = useState();
  const [forwardCache, setForwardCache] = useState();
  const [formValidated, setFormValidated] = useState(false);

  const { state, dispatch: ctxDispatch } = useContext(Store);
  const { userInfo } = state;

  const handleKayitFinish = async () => {
    try {
      dispatch({ type: 'CREATE_REQUEST' });

      dailyReport.excessCache = excessCache;
      dailyReport.missingCache = missingCache;
      dailyReport.description = description;
      dailyReport.forwardCache = forwardCache;

      if (dailyReport._id && isUpdate) {
        await axios.put(`/api/orders/dailyreport/${dailyReport._id}`, {
          dailyReport,
        });
      } else {
        await axios.post('/api/orders/dailyreport', {
          dailyReport: { ...dailyReport, _id: null },
        });
      }
      dispatch({ type: 'CREATE_SUCCESS' });
      toast('Günsonu raporu başarılı bir şekilde gerçekleştirildi!');
      navigate(redirect || '/');
    } catch (err) {
      dispatch({ type: 'CREATE_FAIL' });
      toast.error(getError(err));
    }
  };

  return (
    <Modal
      show={showDailySaveModal}
      onHide={() => setShowDailySaveModal(false)}
      centered
    >
      <Modal.Header closeButton>
        <h5>Gün Sonu Gerçekleştirme</h5>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleKayitFinish}>
          <Form.Group className="mb-3">
            <Form.Label>Açıklama</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              onChange={(e) => setDesctiption(e.target.value)}
              autoFocus
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Kasada Fazla Çıkan Miktar</Form.Label>
            <Form.Control
              type="number"
              onChange={(e) =>
                setExcessCache(e.target.value ? Number(e.target.value) : null)
              }
              autoFocus
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Kasada Eksik Çıkan Miktar</Form.Label>
            <Form.Control
              type="number"
              onChange={(e) =>
                setMissingCache(e.target.value ? Number(e.target.value) : null)
              }
              autoFocus
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Kasada Devreden Miktar</Form.Label>
            <Form.Control
              type="number"
              onChange={(e) =>
                setForwardCache(e.target.value ? Number(e.target.value) : null)
              }
              autoFocus
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button
          size="lg"
          variant="light"
          className="border-primary text-primary"
          type="submit"
          onClick={handleKayitFinish}
          disabled={loadingCreate}
        >
          {loadingCreate ? (
            <>
              {' '}
              <LoadingBox></LoadingBox>
              &nbsp;Kaydediyor...
            </>
          ) : (
            'Kaydet'
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
